/**
 * Löst einen nativen Browser-Download aus, indem der Browser direkt zu der
 * mit dem one-time-token gesicherten URL navigiert.
 *
 * `window.location.href = url` ist der zuverlässigste Weg in Chrome:
 * - Kein JavaScript-Blob-Handling
 * - Kein Anchor-Element-Trick
 * - Chrome verarbeitet Content-Disposition: attachment direkt
 * - Der Dateiname kommt vom Server (Content-Disposition: filename=...)
 *
 * @param {string} apiUrl   - Relative API-URL z.B. '/api/apprentice/weeks/1/download_pdf/'
 * @param {string} authToken - Der JWT Access Token des eingeloggten Nutzers
 * @param {Function} [onError] - Optionale Fehler-Callback(message)
 */
export const nativeDownload = async (apiUrl, authToken, onError) => {
    try {
        if (!authToken) {
            throw new Error('Kein Authentifizierungs-Token gefunden. Bitte neu einloggen.');
        }

        // 1. One-Time-Token vom Server holen (JWT-geschützt)
        const tokenResponse = await fetch('/api/download-token/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify({ url: apiUrl }),
        });

        if (!tokenResponse.ok) {
            const errData = await tokenResponse.json().catch(() => ({}));
            throw new Error(errData.error || 'Download-Token konnte nicht erstellt werden.');
        }

        const { download_url } = await tokenResponse.json();

        // 2. Nativer Browser-Download via window.location.href
        // Chrome bleibt auf der Seite wenn der Server Content-Disposition: attachment sendet.
        // Kein Blob, kein Anchor-Trick – direkte Browser-Navigation.
        window.location.href = download_url;

    } catch (err) {
        console.error('[nativeDownload] Fehler:', err);
        if (onError) onError(err.message || 'Download fehlgeschlagen.');
    }
};
